export const FLASHCARDS = [
  {
    "id": 1,
    "topic_id": 3,
    "title": "ATX and ITX are examples of what?",
    "description": "motherboard form factors."
  },
  {
    "id": 2,
    "topic_id": 3,
    "title": "CPU cache is most commonly implemented using what type of memory?",
    "description": "Static RAM (SRAM)."
  },
  {
    "id": 3,
    "topic_id": 3,
    "title": "What are the two socket types that require little to no force during CPU installation?",
    "description": "Zero Insertion Force (ZIF) and Land Grid Array (LGA)."
  },
  {
    "id": 4,
    "topic_id": 3,
    "title": "What should you apply between the CPU and heat sink to avoid overheating?",
    "description": "thermal compound, thermal paste/pads, or thermal gel."
  },
  {
    "id": 5,
    "topic_id": 3,
    "title": "DDR4 and DDR5 DIMMs have how many pins?",
    "description": "288."
  },
  {
    "id": 6,
    "topic_id": 4,
    "title": "The CPU feature that allows for multiple operating systems to run at once is called what?",
    "description": "virtualization (or virtual technology)."
  },
  {
    "id": 7,
    "topic_id": 2,
    "title": "Which encryption module allows for securing networks and data as well as a local computer?",
    "description": "hardware security module (HSM)."
  },
  {
    "id": 8,
    "topic_id": 3,
    "title": "Which storage communications interface is electrically compatible with SAS?",
    "description": "SATA."
  },
  {
    "id": 9,
    "topic_id": 3,
    "title": "The add-on card that allows your computer to project on a monitor is called what?",
    "description": "video card."
  },
  {
    "id": 10,
    "topic_id": 3,
    "title": "A DVD SS, DL has how much capacity?",
    "description": "8.5 GB."
  },
  {
    "id": 11,
    "topic_id": 3,
    "title": "What does RAID 0 not provide that other levels do?",
    "description": "fault tolerance."
  },
  {
    "id": 12,
    "topic_id": 3,
    "title": "RAID 5 requires a minimum of how many hard drives?",
    "description": "three."
  },
  {
    "id": 13,
    "topic_id": 3,
    "title": "What are four SSD communications interfaces?",
    "description": "NVMe, SATA, PCIe, SAS."
  },
  {
    "id": 14,
    "topic_id": 3,
    "title": "What is another name for hard disk mirroring?",
    "description": "RAID 1."
  },
  {
    "id": 15,
    "topic_id": 3,
    "title": "Which metric should be used to ensure that the PSU can power all components?",
    "description": "wattage rating."
  },
  {
    "id": 16,
    "topic_id": 3,
    "title": "Which RAID systems require a minimum of four disks to implement?",
    "description": "RAID 6 and RAID 10."
  },
  {
    "id": 17,
    "topic_id": 1,
    "title": "Thunderbolt is a combination of which two technologies?",
    "description": "DisplayPort and PCIe."
  },
  {
    "id": 18,
    "topic_id": 3,
    "title": "What connector type provides power to an IDE PATA hard drive?",
    "description": "Molex."
  },
  {
    "id": 19,
    "topic_id": 1,
    "title": "What is the maximum speed of USB 3.0?",
    "description": "5 Gbps."
  },
  {
    "id": 20,
    "topic_id": 1,
    "title": "What is the name of the Apple proprietary connector used on the iPhone 14?",
    "description": "Lightning."
  },
  {
    "id": 21,
    "topic_id": 3,
    "title": "A DB-9 connector is found on which type of cable?",
    "description": "serial."
  },
  {
    "id": 22,
    "topic_id": 3,
    "title": "What is the difference between USB 3.1 and USB-C?",
    "description": "USB 3.1 is a standard, and USB-C is a connector type."
  },
  {
    "id": 23,
    "topic_id": 3,
    "title": "Which display type is most susceptible to burn-in effects?",
    "description": "organic light-emitting diode (OLED)."
  },
  {
    "id": 24,
    "topic_id": 3,
    "title": "Which display attribute describes how quickly the image on the screen is redrawn?",
    "description": "refresh rate."
  },
  {
    "id": 25,
    "topic_id": 3,
    "title": "If icons on the screen are too small to read well, what can the user adjust to help resolve this?",
    "description": "screen resolution."
  },
  {
    "id": 26,
    "topic_id": 3,
    "title": "Which component in the display provides power to the backlight?",
    "description": "inverter."
  },
  {
    "id": 27,
    "topic_id": 1,
    "title": "Where can you obtain laptop service manuals?",
    "description": "from the manufacturer\u2019s website."
  },
  {
    "id": 28,
    "topic_id": 3,
    "title": "What are the three components of an LCD?",
    "description": "inverter, screen, and backlight."
  },
  {
    "id": 29,
    "topic_id": 1,
    "title": "What are three examples of biometrics?",
    "description": "fingerprint, facial scan, retina scan, voice recognition."
  },
  {
    "id": 30,
    "topic_id": 1,
    "title": "Where is the Wi-Fi antenna typically found in a laptop?",
    "description": "in the display."
  },
  {
    "id": 31,
    "topic_id": 3,
    "title": "What step of the EP imaging process uses a laser to discharge selected areas of the photosensitive drum, thus forming an image on the drum?<br>exposing",
    "description": "The last step in the EP imaging process is____."
  },
  {
    "id": 32,
    "topic_id": 3,
    "title": "Which voltage is applied to the paper to transfer the toner to the paper in an EP process laser printer?",
    "description": "+600VDC."
  },
  {
    "id": 33,
    "topic_id": 3,
    "title": "What is the function of the corona assembly?",
    "description": "The corona assembly gets the toner from the photosensitive drum onto the paper."
  },
  {
    "id": 34,
    "topic_id": 2,
    "title": "When a Bluetooth network is created with a printer on the fly, what type of network is it?",
    "description": "ad hoc."
  },
  {
    "id": 35,
    "topic_id": 3,
    "title": "Using an employee\u2019s physical ID to authenticate to a printer is called what?",
    "description": "badging."
  },
  {
    "id": 36,
    "topic_id": 3,
    "title": "What are the three maintenance items for a thermal printer?",
    "description": "Replace paper, clean heating element, remove debris."
  },
  {
    "id": 37,
    "topic_id": 3,
    "title": "What are the three maintenance items for an impact printer?",
    "description": "Replace ribbon, replace printhead, replace paper."
  },
  {
    "id": 38,
    "topic_id": 3,
    "title": "What is it called when a user needs to enter a username and password to use an MFD?",
    "description": "user authentication."
  },
  {
    "id": 39,
    "topic_id": 3,
    "title": "Which printer configuration setting specifies options such as color and resolution?",
    "description": "quality."
  },
  {
    "id": 40,
    "topic_id": 3,
    "title": "STP designed for use outdoors or underground is called what?",
    "description": "direct burial."
  },
  {
    "id": 41,
    "topic_id": 2,
    "title": "A network dedicated to storage devices is called what?",
    "description": "storage area network (SAN)."
  },
  {
    "id": 42,
    "topic_id": 2,
    "title": "To use a wireless network, clients must connect to what type of device?",
    "description": "wireless access point or wireless router."
  },
  {
    "id": 43,
    "topic_id": 2,
    "title": "Networks designed specifically for storage are called what?",
    "description": "storage area network (SAN)."
  },
  {
    "id": 44,
    "topic_id": 2,
    "title": "Which protocol in TCP/IP is responsible for resolving IP addresses to MAC addresses?",
    "description": "ARP (Address Resolution Protocol)."
  },
  {
    "id": 45,
    "topic_id": 2,
    "title": "What is the name of the network type that is segmented using a managed switch?<br>VLAN",
    "description": "How is a static IP address assigned to a computer?"
  },
  {
    "id": 46,
    "topic_id": 2,
    "title": "What two ports does DHCP use?",
    "description": "67, 68."
  },
  {
    "id": 47,
    "topic_id": 2,
    "title": "Ports 137\u2013139 are used by which protocol?",
    "description": "Network Basic Input/Output System (NetBIOS)/NetBIOS over TCP/IP (NetBT)."
  },
  {
    "id": 48,
    "topic_id": 2,
    "title": "RDP uses which port number?",
    "description": "3389."
  },
  {
    "id": 49,
    "topic_id": 2,
    "title": "What type of server resolves hostnames to IP addresses?",
    "description": "DNS."
  },
  {
    "id": 50,
    "topic_id": 2,
    "title": "What does a DHCP server do?",
    "description": "Assigns IP address information to client computers."
  },
  {
    "id": 51,
    "topic_id": 2,
    "title": "What type of server is responsible for holding user files?",
    "description": "Fileshare."
  },
  {
    "id": 52,
    "topic_id": 2,
    "title": "What type of server hosts networked printers?",
    "description": "Print server."
  },
  {
    "id": 53,
    "topic_id": 2,
    "title": "What type of server hosts web pages?",
    "description": "Web server."
  },
  {
    "id": 54,
    "topic_id": 2,
    "title": "What type of server is responsible for providing security and validating users\u2019 login credentials?",
    "description": "Authentication, Authorization, and Accounting (AAA)."
  },
  {
    "id": 55,
    "topic_id": 2,
    "title": "What does an NTP server do?",
    "description": "Provides coordinated time to all devices on a network."
  },
  {
    "id": 56,
    "topic_id": 2,
    "title": "Which Internet appliance coordinates security efforts, including IPS and IDS?",
    "description": "Unified Threat Management (UTM)."
  },
  {
    "id": 57,
    "topic_id": 2,
    "title": "What Internet appliance makes requests of web servers on behalf of clients?",
    "description": "Proxy server."
  },
  {
    "id": 58,
    "topic_id": 2,
    "title": "What type of systems does SCADA refer to?",
    "description": "Legacy hardware or software systems."
  },
  {
    "id": 59,
    "topic_id": 2,
    "title": "An A record in a DNS zone file indicates what type of host?",
    "description": "IPv4."
  },
  {
    "id": 60,
    "topic_id": 2,
    "title": "What type of DNS zone record is for IPv6 hosts?",
    "description": "AAAA."
  },
  {
    "id": 61,
    "topic_id": 2,
    "title": "A CNAME record in a DNS zone file indicates what type of host?",
    "description": "Alias."
  },
  {
    "id": 62,
    "topic_id": 2,
    "title": "What type of record in a DNS zone file can help with spam management?",
    "description": "TXT."
  },
  {
    "id": 63,
    "topic_id": 2,
    "title": "Which type of DNS zone file TXT record validates email servers using a public-private key pair?",
    "description": "DomainKeys Identified Mail (DKIM)."
  },
  {
    "id": 64,
    "topic_id": 2,
    "title": "Which type of DNS zone file TXT record tells an email server how to handle mail marked as spam?",
    "description": "Domain-based Message Authentication, Reporting, and Conformance (DMARC)."
  },
  {
    "id": 65,
    "topic_id": 2,
    "title": "How does a DHCP server determine the IP address given to a client with a reservation?",
    "description": "Based on MAC address."
  },
  {
    "id": 66,
    "topic_id": 2,
    "title": "What type of authentication requires two or more pieces of information to validate a user?",
    "description": "Multifactor authentication (MFA)."
  },
  {
    "id": 67,
    "topic_id": 2,
    "title": "WPA2 employs what security method?",
    "description": "AES-CCMP."
  },
  {
    "id": 68,
    "topic_id": 2,
    "title": "Which Wi-Fi frequency signals can travel the furthest?",
    "description": "2.4 GHz."
  },
  {
    "id": 69,
    "topic_id": 2,
    "title": "Which Wi-Fi standard increases speeds by using 4K-QAM?",
    "description": "Wi-Fi 7 (802.11be)."
  },
  {
    "id": 70,
    "topic_id": 1,
    "title": "Copying data, such as calendars and contacts, photos, and music, between a computer and a mobile device is referred to as what?",
    "description": "Synchronization."
  },
  {
    "id": 71,
    "topic_id": 2,
    "title": "Which TCP ports are used for unsecure and secure IMAP?",
    "description": "Port 143 and port 993, respectively."
  },
  {
    "id": 72,
    "topic_id": 2,
    "title": "Which TCP ports are most commonly used for unsecure and secure SMTP over SSL?",
    "description": "Port 25 and port 465, respectively."
  },
  {
    "id": 73,
    "topic_id": 1,
    "title": "What technology allows pairing of mobile devices and, on occasion, the ability to transfer files between them?",
    "description": "Bluetooth."
  },
  {
    "id": 74,
    "topic_id": 1,
    "title": "When configuring an Internet email account on a mobile device, what are the standard pieces of information required?",
    "description": "Username and password, outbound mail server and port (often based on secure SMTP), and inbound mail server and port (often based on secure POP3 or secure IMAP4)."
  },
  {
    "id": 75,
    "topic_id": 2,
    "title": "What is a data cap?",
    "description": "Limits on the amount of data that can be transferred over a cellular connection in a certain time period."
  },
  {
    "id": 76,
    "topic_id": 1,
    "title": "What are two types of MDM device configurations?",
    "description": "Corporate and BYOD."
  },
  {
    "id": 77,
    "topic_id": 4,
    "title": "What is the term for cloud service where the provider offers applications?",
    "description": "Software as a service (SaaS)."
  },
  {
    "id": 78,
    "topic_id": 4,
    "title": "What type of cloud is completely owned by a company like Google but used by business clients?",
    "description": "Public."
  },
  {
    "id": 79,
    "topic_id": 4,
    "title": "The ability to access extra cloud resources quickly is called what?",
    "description": "Elasticity (or rapid elasticity)."
  },
  {
    "id": 80,
    "topic_id": 4,
    "title": "What type of hypervisor is also referred to as a bare metal hypervisor?",
    "description": "Type 1."
  },
  {
    "id": 81,
    "topic_id": 4,
    "title": "What virtualization technology is used to quickly deploy apps?",
    "description": "Containers."
  },
  {
    "id": 82,
    "topic_id": 4,
    "title": "What type of cloud is a combination of public and private?",
    "description": "Hybrid."
  },
  {
    "id": 83,
    "topic_id": 4,
    "title": "What type of hypervisor is best suited to client-side virtualization?",
    "description": "Type 2."
  },
  {
    "id": 84,
    "topic_id": 5,
    "title": "Unexpected shutdowns, system lockups, or continuous reboots are most often caused by which hardware components?",
    "description": "Motherboard, CPU, or RAM."
  },
  {
    "id": 85,
    "topic_id": 5,
    "title": "Which troubleshooting device can help determine problems during the boot process?",
    "description": "POST card."
  },
  {
    "id": 86,
    "topic_id": 3,
    "title": "Where is the boot sequence stored in the computer?",
    "description": "BIOS/UEFI settings."
  },
  {
    "id": 87,
    "topic_id": 5,
    "title": "Which system component is most likely to overheat?",
    "description": "CPU."
  },
  {
    "id": 88,
    "topic_id": 5,
    "title": "If when the computer is turned on, the fan spins but no devices seem to have power, which component is most likely at fault?",
    "description": "Power supply."
  },
  {
    "id": 89,
    "topic_id": 5,
    "title": "Smoke or a burning smell is most likely the fault of which component?",
    "description": "Power supply."
  },
  {
    "id": 90,
    "topic_id": 5,
    "title": "The macOS proprietary crash screen is called what?",
    "description": "Pinwheel."
  },
  {
    "id": 91,
    "topic_id": 2,
    "title": "To communicate on a TCP/IPv4 network, which two things do you need?",
    "description": "A unique IP address and a valid subnet mask."
  },
  {
    "id": 92,
    "topic_id": 3,
    "title": "What is S.M.A.R.T. technology used for?",
    "description": "To detect potential hard drive errors."
  },
  {
    "id": 93,
    "topic_id": 2,
    "title": "What hardware tool is used to put the ends on UTP cables?",
    "description": "Crimper."
  },
  {
    "id": 94,
    "topic_id": 2,
    "title": "If you believe you have a bad network cable, what tool can help you test it?",
    "description": "Cable tester."
  },
  {
    "id": 95,
    "topic_id": 2,
    "title": "What networking tool can make a copy of network traffic for additional analysis?",
    "description": "Network tap."
  },
  {
    "id": 96,
    "topic_id": 5,
    "title": "What is the most common cause of latency on a network?",
    "description": "Too many users (or too much traffic)."
  },
  {
    "id": 97,
    "topic_id": 2,
    "title": "What tool is used to connect wires to a 110-block?",
    "description": "Punchdown tool."
  },
  {
    "id": 98,
    "topic_id": 5,
    "title": "Consistently light or faded characters on output from an impact printer likely indicates what?",
    "description": "The print ribbon is old and needs to be replaced."
  },
  {
    "id": 99,
    "topic_id": 5,
    "title": "Unevenly spaced characters in output from an impact or inkjet printer could indicate what?",
    "description": "A problem with the stepper motor."
  },
  {
    "id": 100,
    "topic_id": 5,
    "title": "A paper jam in an inkjet printer is usually caused by what two things?",
    "description": "Worn pickup rollers or the wrong type of paper."
  },
  {
    "id": 101,
    "topic_id": 3,
    "title": "What are two ways you can manually configure your laser printer\u2019s IP address?",
    "description": "Through the control panel on the printer and using management software on your computer."
  },
  {
    "id": 102,
    "topic_id": 5,
    "title": "Vertical white lines on the output of a laser printer are caused by what?",
    "description": "Foreign matter (more than likely toner) caught on the transfer corona wire."
  },
  {
    "id": 103,
    "topic_id": 5,
    "title": "What causes image smudging from a laser printer?",
    "description": "The fuser isn\u2019t heating the toner and fusing it into the paper."
  },
  {
    "id": 104,
    "topic_id": 5,
    "title": "If the video on a laptop is not working, you should plug in what?",
    "description": "An external monitor."
  },
  {
    "id": 105,
    "topic_id": 1,
    "title": "How do you fix a swollen battery on a mobile device?",
    "description": "Replace it."
  },
  {
    "id": 106,
    "topic_id": 3,
    "title": "What type of conventional CPU cooling method is relatively quiet and affords the greatest drops in temperature?<br>water or liquid cooling",
    "description": "If the fan on the power supply is an exhaust-oriented fan, then the fan on the front fan should be __________ oriented, while the rear supplemental fan should be __________ oriented."
  },
  {
    "id": 107,
    "topic_id": 3,
    "title": "What is the name for the CPU/socket format that places the pins on the motherboard instead of the CPU?",
    "description": "Land Grid Array (LGA)."
  },
  {
    "id": 108,
    "topic_id": 3,
    "title": "What is the most common type of memory packaging for laptops?",
    "description": "SODIMM."
  },
  {
    "id": 109,
    "topic_id": 3,
    "title": "What is it called when a CPU core can run multiple instruction streams at once?",
    "description": "Hyperthreading."
  },
  {
    "id": 110,
    "topic_id": 3,
    "title": "What is it called when a CPU essentially has several processors built into one package?",
    "description": "Multicore."
  },
  {
    "id": 111,
    "topic_id": 5,
    "title": "Which RAID level provides no fault tolerance?",
    "description": "RAID 0."
  },
  {
    "id": 112,
    "topic_id": 3,
    "title": "To which power supply output voltage does \u201cdual rail\u201d apply?",
    "description": "12VDC."
  },
  {
    "id": 113,
    "topic_id": 3,
    "title": "What type of device holds nearly as much data as a conventional hard disk drive but has no moving parts?",
    "description": "solid-state drive (SSD)."
  },
  {
    "id": 114,
    "topic_id": 3,
    "title": "Which RAID level provides both disk striping and mirroring?",
    "description": "RAID 10 (1+0)."
  },
  {
    "id": 115,
    "topic_id": 3,
    "title": "What do optical disc drives use to read and write data to a disc?",
    "description": "A laser."
  },
  {
    "id": 116,
    "topic_id": 3,
    "title": "What is the capacity of a single-side, single-layer DVD?",
    "description": "4.7 GB."
  },
  {
    "id": 117,
    "topic_id": 3,
    "title": "A power supply with multiple attachable and detachable power cords is called what?",
    "description": "A modular power supply."
  },
  {
    "id": 118,
    "topic_id": 3,
    "title": "A power supply that takes over in case of a PSU failure is called what?",
    "description": "A redundant power supply."
  },
  {
    "id": 119,
    "topic_id": 3,
    "title": "Which two video standards are always digital?",
    "description": "HDMI and DisplayPort."
  },
  {
    "id": 120,
    "topic_id": 3,
    "title": "A peripheral serial cable will have which type of connector?",
    "description": "DB-9."
  },
  {
    "id": 121,
    "topic_id": 3,
    "title": "What does a Molex connector do?",
    "description": "Provides power to PATA hard drives or optical drives."
  },
  {
    "id": 122,
    "topic_id": 3,
    "title": "Which USB cable type provides for the best speeds?",
    "description": "USB-C."
  },
  {
    "id": 123,
    "topic_id": 3,
    "title": "A Lightning connector is found on which type of cable?",
    "description": "USB."
  },
  {
    "id": 124,
    "topic_id": 3,
    "title": "External storage devices will typically connect using one of which two technologies?",
    "description": "USB or eSATA."
  },
  {
    "id": 125,
    "topic_id": 3,
    "title": "What is the difference between DVI-A and DVI-D?",
    "description": "DVI-A is analog; DVI-D is digital."
  },
  {
    "id": 126,
    "topic_id": 3,
    "title": "How do you connect a DVI monitor to an HDMI video card?",
    "description": "By using a DVI to HDMI adapter."
  },
  {
    "id": 127,
    "topic_id": 1,
    "title": "USB4 was based on which standard?",
    "description": "Thunderbolt 3."
  },
  {
    "id": 128,
    "topic_id": 3,
    "title": "Which display attribute describes how many pixels wide the image is?",
    "description": "Screen resolution."
  },
  {
    "id": 129,
    "topic_id": 3,
    "title": "Which display attribute describes the range of colors supported by a display?",
    "description": "Color gamut."
  },
  {
    "id": 130,
    "topic_id": 3,
    "title": "If fast-moving images on a display are choppy or blurry, what should the user increase to resolve the problem?",
    "description": "Refresh rate."
  },
  {
    "id": 131,
    "topic_id": 3,
    "title": "What is the job of an inverter in an LCD display?",
    "description": "Convert DC power to AC power for the backlight."
  },
  {
    "id": 132,
    "topic_id": 3,
    "title": "A DDR4 SODIMM has a minimum of how may pins?",
    "description": "260."
  },
  {
    "id": 133,
    "topic_id": 3,
    "title": "The power supply for the LCD backlight is called what?",
    "description": "inverter."
  },
  {
    "id": 134,
    "topic_id": 3,
    "title": "What is the part of the LCD that is responsible for displaying information?",
    "description": "screen."
  },
  {
    "id": 135,
    "topic_id": 3,
    "title": "A DDR3 SODIMM has how many pins?",
    "description": "204."
  },
  {
    "id": 136,
    "topic_id": 3,
    "title": "Which component in a laptop display allows for audio input?",
    "description": "microphone."
  },
  {
    "id": 137,
    "topic_id": 3,
    "title": "Which component in a laptop display can take input from a user\u2019s finger and turn it into digital data?",
    "description": "digitizer."
  },
  {
    "id": 138,
    "topic_id": 3,
    "title": "Which component in a laptop display allows for video input?",
    "description": "webcam."
  },
  {
    "id": 139,
    "topic_id": 3,
    "title": "In the EP imaging process, what is the function of the laser?",
    "description": "It writes the image to the drum."
  },
  {
    "id": 140,
    "topic_id": 3,
    "title": "What is the EP imaging process stage where the corona wire/roller acquires a strong positive charge (+600VDC) and applies that charge to the paper?",
    "description": "transferring."
  },
  {
    "id": 141,
    "topic_id": 3,
    "title": "Which EP component takes wall voltage and converts it into current that the printer uses?",
    "description": "high-voltage power supply (HVPS)."
  },
  {
    "id": 142,
    "topic_id": 3,
    "title": "During which EP imaging process step is a uniform negative charge (around \u2013600VDC) applied to the surface of the photosensitive drum?",
    "description": "charging."
  },
  {
    "id": 143,
    "topic_id": 3,
    "title": "During which step of the EP imaging process is toner transferred to the drum?",
    "description": "developing."
  },
  {
    "id": 144,
    "topic_id": 3,
    "title": "During which step of the EP imaging process does the toner move from the drum to the paper?",
    "description": "transferring."
  },
  {
    "id": 145,
    "topic_id": 3,
    "title": "What will happen to the drum of an EP printer if it\u2019s exposed to light?",
    "description": "It will be ruined."
  },
  {
    "id": 146,
    "topic_id": 3,
    "title": "What are two methods of authenticating to an MFD?",
    "description": "Typing in a username and password, and badging."
  },
  {
    "id": 147,
    "topic_id": 3,
    "title": "MFDs use SMB to do what?",
    "description": "Send a scan to a network folder."
  },
  {
    "id": 148,
    "topic_id": 3,
    "title": "What are the four maintenance items for a laser printer?",
    "description": "Replace toner, apply maintenance kit, calibrate, and clean."
  },
  {
    "id": 149,
    "topic_id": 3,
    "title": "What are the four maintenance kits items for an inkjet printer?",
    "description": "Clean printheads, replace cartridges, calibrate, and clear jams."
  },
  {
    "id": 150,
    "topic_id": 3,
    "title": "What is it called when a printer holds the print job until the user arrives and tells it to start?",
    "description": "secured prints."
  },
  {
    "id": 151,
    "topic_id": 3,
    "title": "Which printer configuration setting tells the printer to print on both sides of the page?",
    "description": "duplex."
  },
  {
    "id": 152,
    "topic_id": 3,
    "title": "Which printer configuration setting specifies portrait versus landscape printing?",
    "description": "orientation."
  },
  {
    "id": 153,
    "topic_id": 3,
    "title": "Which printer configuration setting tells the printer where to get paper from?",
    "description": "tray settings."
  },
  {
    "id": 154,
    "topic_id": 3,
    "title": "What are the three preferred methods to connect a printer?",
    "description": "USB, Ethernet, wireless."
  },
  {
    "id": 155,
    "topic_id": 3,
    "title": "What does a SAN use to more efficiently store data?",
    "description": "block-level storage."
  },
  {
    "id": 156,
    "topic_id": 2,
    "title": "What is the device used to get Internet access from fiber-optic lines coming from the ISP?",
    "description": "optical network terminal (ONT)."
  },
  {
    "id": 157,
    "topic_id": 3,
    "title": "What type of network cable does not produce poisonous gas when burned?",
    "description": "plenum."
  },
  {
    "id": 158,
    "topic_id": 3,
    "title": "Coax cable uses what type of connector?",
    "description": "F-type (BNC is also acceptable but is not an exam objective)."
  },
  {
    "id": 159,
    "topic_id": 3,
    "title": "What type of cable is used with a punchdown block?",
    "description": "copper (specifically twisted pair)."
  },
  {
    "id": 160,
    "topic_id": 3,
    "title": "F-type connectors are used for what type of cable?",
    "description": "coaxial."
  },
  {
    "id": 161,
    "topic_id": 3,
    "title": "An RJ45 connector is used with what type of cable?",
    "description": "twisted pair."
  },
  {
    "id": 162,
    "topic_id": 2,
    "title": "piconet, scatternet <br>What are three networking devices used to get PCs onto the Internet?",
    "description": "cable modem, DSL modem, ONT."
  },
  {
    "id": 163,
    "topic_id": 2,
    "title": "Which protocol is responsible for delivering error messages in TCP/IP?",
    "description": "ICMP (Internet Control Message Protocol)."
  },
  {
    "id": 164,
    "topic_id": 2,
    "title": "To communicate on a TCP/IP network, which two things do you need?",
    "description": "a unique IP address and a valid subnet mask."
  },
  {
    "id": 165,
    "topic_id": 2,
    "title": "What is a secure point-to-point connection over a public network called?",
    "description": "VPN."
  },
  {
    "id": 166,
    "topic_id": 2,
    "title": "How is a dynamic IP address assigned to a computer?",
    "description": "from a DHCP server."
  },
  {
    "id": 167,
    "topic_id": 2,
    "title": "Port 143 is used by which protocol?",
    "description": "IMAP."
  },
  {
    "id": 168,
    "topic_id": 2,
    "title": "LDAP uses which port number?",
    "description": "389."
  },
  {
    "id": 169,
    "topic_id": 2,
    "title": "SMB and CIFS use which port number?",
    "description": "445."
  },
  {
    "id": 170,
    "topic_id": 2,
    "title": "What does a DNS server do?",
    "description": "resolves hostnames to IP addresses."
  },
  {
    "id": 171,
    "topic_id": 2,
    "title": "What type of server assigns IP addresses to clients?",
    "description": "DHCP."
  },
  {
    "id": 172,
    "topic_id": 2,
    "title": "What type of server sends and receives email?",
    "description": "mail server."
  },
  {
    "id": 173,
    "topic_id": 2,
    "title": "What type of server tracks and stores network error messages?",
    "description": "syslog."
  },
  {
    "id": 174,
    "topic_id": 2,
    "title": "What type of server runs software such as SQL or Oracle?",
    "description": "database server."
  },
  {
    "id": 175,
    "topic_id": 2,
    "title": "What type of server coordinates time on devices across a network?",
    "description": "Network Time Protocol (NTP)."
  },
  {
    "id": 176,
    "topic_id": 2,
    "title": "What are two examples of load balancing?",
    "description": "geographical and content-based."
  },
  {
    "id": 177,
    "topic_id": 2,
    "title": "An AAAA record in a DNS zone file indicates what type of host?",
    "description": "IPv6."
  },
  {
    "id": 178,
    "topic_id": 2,
    "title": "What type of DNS zone record is for aliases?",
    "description": "CNAME."
  },
  {
    "id": 179,
    "topic_id": 2,
    "title": "An MX record in a DNS zone file indicates what type of host?",
    "description": "Mail server."
  },
  {
    "id": 180,
    "topic_id": 2,
    "title": "Which type of DNS zone file TXT record validates email servers based on their IP address?",
    "description": "Sender Policy Framework (SPF)."
  },
  {
    "id": 181,
    "topic_id": 2,
    "title": "What type of authentication requires only one piece of information, such as a password?",
    "description": "single-factor authentication (SFA)."
  },
  {
    "id": 182,
    "topic_id": 2,
    "title": "Mail servers work with which three protocols?",
    "description": "SMTP, POP3, IMAP4."
  },
  {
    "id": 183,
    "topic_id": 2,
    "title": "What type of Internet appliance can help spread out traffic among multiple servers?",
    "description": "load balancer."
  },
  {
    "id": 184,
    "topic_id": 2,
    "title": "On a 2.4 GHz Wi-Fi network, what are the three nonoverlapping channels?",
    "description": "1, 6, and 11."
  },
  {
    "id": 185,
    "topic_id": 2,
    "title": "What technology is deigned to be \u201cplug and play\u201d for network devices?",
    "description": "UPnP."
  },
  {
    "id": 186,
    "topic_id": 2,
    "title": "Which Wi-Fi frequency offers the highest transmission speeds?",
    "description": "6 GHz."
  },
  {
    "id": 187,
    "topic_id": 2,
    "title": "Which Wi-Fi standard improved speeds by allowing devices to communicate over two channels at the same time?",
    "description": "Wi-Fi 7 (802.11be)."
  },
  {
    "id": 188,
    "topic_id": 2,
    "title": "Which wireless technology uses tags and readers to track information?",
    "description": "RFID."
  },
  {
    "id": 189,
    "topic_id": 2,
    "title": "Which Internet connection type uses an ONT?",
    "description": "fiber."
  },
  {
    "id": 190,
    "topic_id": 2,
    "title": "Which two Internet connection types require line of sight?",
    "description": "satellite, WISP."
  },
  {
    "id": 191,
    "topic_id": 1,
    "title": "What is it called when a laptop gets on the Internet using a cellular connection?<br>mobile hotspot",
    "description": "Connecting a device to a mobile hotspot is referred to as what?"
  },
  {
    "id": 192,
    "topic_id": 1,
    "title": "What are two locations to which you can sync an iPhone?",
    "description": "the desktop (iTunes) and the cloud (iCloud)."
  },
  {
    "id": 193,
    "topic_id": 1,
    "title": "What service allows network administrators to set system policies and remotely wipe mobile devices on a network?",
    "description": "mobile device management (MDM)."
  },
  {
    "id": 194,
    "topic_id": 2,
    "title": "Which TCP ports are used for unsecure and secure POP3?",
    "description": "110 and 995, respectively."
  },
  {
    "id": 195,
    "topic_id": 4,
    "title": "What is the term for cloud service where the provider offers storage only?<br>infrastructure as a service (IaaS)",
    "description": "What is the name of the software that allows for multiple VMs on a client computer?"
  },
  {
    "id": 196,
    "topic_id": 4,
    "title": "What type of cloud is owned and used by an individual company?",
    "description": "private."
  },
  {
    "id": 197,
    "topic_id": 4,
    "title": "The ability of a cloud provider to bundle multiple physical servers together to appear as one set of resources to the client is called what?",
    "description": "shared resources or resource pooling."
  },
  {
    "id": 198,
    "topic_id": 4,
    "title": "Hypervisors manage VM network traffic and communicate to the physical NIC by using what?",
    "description": "virtual switch."
  },
  {
    "id": 199,
    "topic_id": 4,
    "title": "Which virtualization technology ensures that apps have consistent performance across operating environments?",
    "description": "containers."
  },
  {
    "id": 200,
    "topic_id": 5,
    "title": "When a system boots up, it provides a beep code. Where can you check to see what it means?<br>the BIOS/UEFI manufacturer\u2019s website",
    "description": "If the system BIOS/UEFI forgets the time and date after a reboot, what likely needs to be replaced?"
  },
  {
    "id": 201,
    "topic_id": 5,
    "title": "If you try to turn a desktop computer on and there is no power, what is the most likely device to cause this?",
    "description": "power supply."
  },
  {
    "id": 202,
    "topic_id": 5,
    "title": "Which devices in a computer are most likely to make unexpected loud noises, indicating a problem?",
    "description": "HDDs, fans, power supply."
  },
  {
    "id": 203,
    "topic_id": 2,
    "title": "What do switches and routers have that indicate if a port is working properly?",
    "description": "indicator lights."
  },
  {
    "id": 204,
    "topic_id": 5,
    "title": "What is the Windows proprietary crash screen called?",
    "description": "blue screen of death (BSOD)."
  },
  {
    "id": 205,
    "topic_id": 5,
    "title": "Which component, when it fails, may be swollen or release a brownish-red electrolyte?",
    "description": "capacitor (distended capacitor)."
  },
  {
    "id": 206,
    "topic_id": 3,
    "title": "What technology is built into hard drives to detect problems?",
    "description": "S.M.A.R.T."
  },
  {
    "id": 207,
    "topic_id": 2,
    "title": "What hardware tool is used to trace cables through a wall?",
    "description": "toner and probe."
  },
  {
    "id": 208,
    "topic_id": 2,
    "title": "What tool can be used to discover wireless network traffic?",
    "description": "a Wi-Fi analyzer or wireless locator."
  },
  {
    "id": 209,
    "topic_id": 2,
    "title": "What tool is used to test a network card, without using a network cable?",
    "description": "loopback adapter or plug."
  },
  {
    "id": 210,
    "topic_id": 2,
    "title": "What is jitter?",
    "description": "variable latency on a network."
  },
  {
    "id": 211,
    "topic_id": 5,
    "title": "A small dark line across rows of printing on output from an impact printer indicates what?",
    "description": "A pin is stuck out in the printhead."
  },
  {
    "id": 212,
    "topic_id": 5,
    "title": "Blank pages from a laser printer could be caused by which three things?",
    "description": "the toner cartridge, the transfer corona assembly, or the high-voltage power supply (HVPS)."
  },
  {
    "id": 213,
    "topic_id": 5,
    "title": "Vertical black lines on the output of a laser printer are caused by what?",
    "description": "a groove or scratch in the EP drum."
  },
  {
    "id": 214,
    "topic_id": 5,
    "title": "The most likely cause of a printer printing garbage is what?",
    "description": "the print driver."
  },
  {
    "id": 215,
    "topic_id": 3,
    "title": "If your inkjet printheads are dirty, what can you use to clean them?",
    "description": "an inkjet printer cleaning solution."
  },
  {
    "id": 216,
    "topic_id": 5,
    "title": "If built-in wireless isn\u2019t working on a laptop, you should look for what?",
    "description": "lights on the network card, or an external network card toggle switch."
  },
  {
    "id": 217,
    "topic_id": 3,
    "title": "Paper size and orientation are set where?",
    "description": "printing preferences of the printer."
  },
  {
    "id": 218,
    "topic_id": 200,
    "title": "Know three form factors of system boards.",
    "description": "Know the characteristics of and differences between ATX, microATX, and ITX motherboards."
  },
  {
    "id": 219,
    "topic_id": 200,
    "title": "Know the components of a motherboard.",
    "description": "Be able to describe, identify, and replace (where applicable) motherboard components, such as expansion slots, memory slots, processor sockets, BIOS/UEFI (firmware), and CMOS batteries."
  },
  {
    "id": 220,
    "topic_id": 200,
    "title": "Be able to identify and differentiate motherboard connector types.",
    "description": "Understand the differences between PCI, PCIe, SATA, eSATA, and M.2 connectors, as well as power connectors and headers."
  },
  {
    "id": 221,
    "topic_id": 200,
    "title": "Understand core concepts of motherboard compatibility.",
    "description": "Know that Intel and AMD chips use different sockets and therefore are incompatible with each other. Also know differences between multisocket, desktop, and laptop motherboards."
  },
  {
    "id": 222,
    "topic_id": 200,
    "title": "Understand CPU architecture.",
    "description": "Know the differences between x64, x86, and ARM processors, implications of single-core versus multicore CPUs, and multithreading and virtualization support."
  },
  {
    "id": 223,
    "topic_id": 200,
    "title": "Know what the BIOS/UEFI is responsible for.",
    "description": "The BIOS/UEFI controls boot options, fan speeds, temperature monitoring, USB permissions, and security options such as the BIOS password, boot password, TPM, HSM, and Secure Boot."
  },
  {
    "id": 224,
    "topic_id": 200,
    "title": "Understand the purposes and characteristics of memory.",
    "description": "Know about the characteristics that set the various types of memory apart from one another. This includes the actual types of memory, such as DRAM (which includes several varieties), SRAM, ROM, and CMOS, as well as memory packaging, such as DIMMs and SODIMMs. Also have a firm understanding of the different levels of cache memory as well as its purpose in general."
  },
  {
    "id": 225,
    "topic_id": 200,
    "title": "Know how to replace RAM, given a scenario.",
    "description": "RAM must match the motherboard in form factor and in speed. For example, some motherboards will only accept DDR4 or DDR5 memory. The speed should be compatible with the motherboard, as indicated in the documentation."
  },
  {
    "id": 226,
    "topic_id": 200,
    "title": "Understand the purposes and characteristics of cooling systems.",
    "description": "Know the different ways internal components can be cooled and how overheating can be prevented. Most cooling systems involve a fan, a heat sink, or a combination of the two, or liquid cooling and a fan. Heat sinks and fans are often attached with thermal paste or a thermal pad."
  },
  {
    "id": 227,
    "topic_id": 200,
    "title": "Know how to install and configure expansion cards to provide needed functionality.",
    "description": "Understand the functionality that video cards, sound cards, network cards, and capture cards provide. Know where to install them and broadly how to configure them."
  },
  {
    "id": 228,
    "topic_id": 200,
    "title": "Be familiar with the components of a conventional hard drive and the anatomy of a hard drive.",
    "description": "Conventional hard drives store data magnetically on rotating metal platters. Be familiar with magnetic hard drive speeds, including 5,400, 7,200, 10,000, and 15,000 rpm. Form factors are 2.5\u2033 and 3.5\u2033."
  },
  {
    "id": 229,
    "topic_id": 200,
    "title": "Understand the advantages that solid-state drives have over conventional drives.",
    "description": "SSDs are much faster than magnetic hard drives, produce less heat, and can be made much smaller physically. They are also less susceptible to shock from drops."
  },
  {
    "id": 230,
    "topic_id": 200,
    "title": "Know the differences between three SSD communications interfaces and two form factors.",
    "description": "The SSD communications interfaces are NVMe, SATA, PCIe, and SAS. The two form factors to know are M.2 and mSATA."
  },
  {
    "id": 231,
    "topic_id": 200,
    "title": "Understand the details surrounding optical storage.",
    "description": "From capacities to speeds, you should know what the varieties of optical storage offer. Blu-ray is the newest, fastest, and largest capacity, followed by DVDs and finally CDs."
  },
  {
    "id": 232,
    "topic_id": 200,
    "title": "Understand the different flash drive and memory card options available.",
    "description": "Know the differences between SD cards, CompactFlash, microSD, and miniSD. Be able to identify which cards can fit into specific types of slots natively or with an adapter."
  },
  {
    "id": 233,
    "topic_id": 200,
    "title": "Understand the characteristics of five types of RAID configurations.",
    "description": "You need to know RAID 0, RAID 1, RAID 5, RAID 6, and RAID 10. RAID 0 is disk striping, which can improve speed but does not provide fault tolerance. RAID 1 is disk mirroring, which gives fault tolerance but no performance increase. RAID 5 is striping with parity, which can give some performance boost along with fault tolerance. RAID 6 is double-parity RAID. It's similar to RAID 5, with a second parity stripe. RAID 10, also known as RAID 1+0, adds mirroring to a striped set. Understand what hot-swappable means."
  },
  {
    "id": 234,
    "topic_id": 200,
    "title": "Know about power supplies and their connectors.",
    "description": "Power supplies are commonly made in ATX and other, smaller form factors. Regardless of their type, power supplies must offer connectors for motherboards and internal devices. Know the differences among the connectors and why you might need a 20-pin to 24-pin motherboard adapter. Also understand why AC adapters are related to power supplies."
  },
  {
    "id": 235,
    "topic_id": 200,
    "title": "Understand power supply characteristics that determine performance.",
    "description": "Power supplies can take AC input from 110V to 240V and may have a switch on the back to determine which source to expect. Output to internal components will be 3.3V, 5V, and 12V. Capacity is measured in watts and expressed as a wattage rating. The amount of AC energy converted to DC power is called energy efficiency\u2014the higher, the better. There are also redundant and modular power supplies."
  },
  {
    "id": 236,
    "topic_id": 200,
    "title": "Know how to remove, install, and configure storage devices.",
    "description": "Know the difference between the data and power connectors used on storage devices. Know what it means to partition and format a hard drive. Be aware of the physical differences in storage device form factors."
  },
  {
    "id": 237,
    "topic_id": 200,
    "title": "Know how to remove, install, and configure power supplies.",
    "description": "Know the difference between the modern motherboard power headers and know when an adapter might be required. Be familiar with how to fasten power supplies to the chassis as well as how to unfasten them."
  },
  {
    "id": 238,
    "topic_id": 200,
    "title": "Understand the differences between display types.",
    "description": "You should be able to know the advantages and disadvantages of using IPS, TN, and VA LCD displays, as well as OLEDs and mini-LEDs."
  },
  {
    "id": 239,
    "topic_id": 200,
    "title": "Know what touch screens, digitizers, and inverters are used for.",
    "description": "Touchscreens and digitizers have the same function, which is to take physical input from a finger or stylus and convert that to digital signals for the computing device to use. An inverter is a small circuit board that converts DC power to AC power for an LCD backlight."
  },
  {
    "id": 240,
    "topic_id": 200,
    "title": "Know four different display attributes.",
    "description": "Be familiar with pixel density (the number of pixels per inch), refresh rates (how often the screen is redrawn), screen resolution (the number of pixels across and down on a display), and color gamut (the range of colors a display can produce)."
  },
  {
    "id": 241,
    "topic_id": 200,
    "title": "Recognize and understand different peripheral connectors and adapters.",
    "description": "Expansion cards and motherboards have external connectivity interfaces. The interfaces have connectors that adhere to some sort of standard for interconnecting with a cable or external device. Knowing these specific characteristics can help you differentiate among the capabilities of the interfaces available to you. Understanding when to use an adapter to convert one connector to another is crucial to achieving connectivity among differing interfaces. Adapters you should know are DVI to HDMI, USB to Ethernet, and DVI to VGA."
  },
  {
    "id": 242,
    "topic_id": 200,
    "title": "Recognize and be able to describe display connectors specifically.",
    "description": "Although a type of peripheral connector, display connectors are in a class all their own. Types include VGA, various versions of DVI, HDMI, mini-HDMI, DisplayPort, and USB-C."
  },
  {
    "id": 243,
    "topic_id": 200,
    "title": "Recognize and understand the purpose of hard drive cables and connectors.",
    "description": "The connectors you should recognize are SATA and eSATA. Molex connectors are used to power older PATA devices. They each connect hard drives or optical drives."
  },
  {
    "id": 244,
    "topic_id": 200,
    "title": "Know the various peripheral cables and their connectors.",
    "description": "Multipurpose cables include USB, Lightning, Thunderbolt, and serial. USB has the largest variety of connectors, including USB-A and USB-B and their mini- and micro- versions, as well as the newer USB-C. USB cables also can have proprietary connectors, such as Apple's Lightning connector. Thunderbolt can use a proprietary connector or USB-C. Serial cables have a DB-9 connector."
  },
  {
    "id": 245,
    "topic_id": 200,
    "title": "Understand how to install and configure laptop components.",
    "description": "Components include the battery, keyboard, RAM, hard drives and solid-state drives, and wireless cards."
  },
  {
    "id": 246,
    "topic_id": 200,
    "title": "Know laptop physical privacy and security components.",
    "description": "They include biometrics and near-field scanner features."
  },
  {
    "id": 247,
    "topic_id": 200,
    "title": "Understand the components that make up a display in a mobile device.",
    "description": "Display components include the screen, which may be a touchscreen or include a digitizer; Wi-Fi antenna; camera or webcam; microphone; and inverter."
  },
  {
    "id": 248,
    "topic_id": 200,
    "title": "Know how to connect mobile device accessories.",
    "description": "Connection methods include USB, Lightning, serial, near-field communication (NFC), Bluetooth, and tethering/hotspot."
  },
  {
    "id": 249,
    "topic_id": 200,
    "title": "Be familiar with mobile device accessories.",
    "description": "Ones to know include touch pens, trackpads/drawing pads/track points, stylus, headsets, speakers, webcams, docking stations, and port replicators."
  },
  {
    "id": 250,
    "topic_id": 200,
    "title": "Know the differences between types of printer technologies (for example, laser, inkjet, thermal, impact).",
    "description": "Laser printers use a laser and toner to create the page. Inkjet printers spray ink onto the page. Thermal printers use heat to form the characters on the page. Impact printers use a mechanical device to strike a ribbon, thus forming an image on the page."
  },
  {
    "id": 251,
    "topic_id": 200,
    "title": "Know the three most common ways to connect a printer.",
    "description": "The methods are USB, Ethernet, and wireless."
  },
  {
    "id": 252,
    "topic_id": 200,
    "title": "Be familiar with printer configuration settings.",
    "description": "Know how duplex, orientation, tray settings, and print quality are configured."
  },
  {
    "id": 253,
    "topic_id": 200,
    "title": "For networked printers, understand security and scan services options.",
    "description": "Security can include user authentication and badging, audit logs, and secured prints. Network scan services include scan to email, scan to a folder (using the SMB protocol), and scan to cloud."
  },
  {
    "id": 254,
    "topic_id": 200,
    "title": "Understand what print servers and printer shares are.",
    "description": "A shared printer is one that's made available to users across the network. The print server is the computer or system that hosts the shared printer."
  },
  {
    "id": 255,
    "topic_id": 200,
    "title": "Know the seven steps in the laser imaging process.",
    "description": "The seven steps are processing, charging, exposing, developing, transferring, fusing, and cleaning."
  },
  {
    "id": 256,
    "topic_id": 200,
    "title": "Know the key parts in a laser printer and appropriate maintenance procedures.",
    "description": "Key parts are the imaging drum, fuser assembly, transfer belt, transfer roller, pickup rollers, separation pads, and duplexing assembly. Maintenance includes replacing toner, applying a maintenance kit, calibrating, and cleaning."
  },
  {
    "id": 257,
    "topic_id": 200,
    "title": "Know the key parts in an inkjet printer and appropriate maintenance procedures.",
    "description": "Inkjet parts include the ink cartridge, printhead, roller, feeder, duplexing assembly, and carriage belt. Maintenance items include cleaning printheads, replacing cartridges, calibrating, and clearing paper jams."
  },
  {
    "id": 258,
    "topic_id": 200,
    "title": "Know the key components in a thermal printer and appropriate maintenance procedures.",
    "description": "The feed assembly and heating element are important thermal printer parts. The paper is also important here because it's special heat-sensitive thermal paper. Maintenance includes replacing paper, cleaning the heating element, and removing debris."
  },
  {
    "id": 259,
    "topic_id": 200,
    "title": "Know the key parts in an impact printer and appropriate maintenance procedures.",
    "description": "Impact printer parts to know include the printhead, ribbon, tractor feed (and special tractor feed paper), and impact or multipart paper. Maintenance includes replacing the ribbon, printhead, and paper."
  },
  {
    "id": 260,
    "topic_id": 200,
    "title": "Understand the importance of using recommended supplies.",
    "description": "Using consumables (paper, ink, toner) that are recommended for your printer is important. Using bad supplies could ruin your printer and void your warranty."
  },
  {
    "id": 261,
    "topic_id": 200,
    "title": "Know the difference between LANs, WANs, PANs, MANs, SANs, and WLANs.",
    "description": "A LAN is a local area network, which typically means a network in one centralized location. A WAN is a wide area network, which means several LANs in remote locations connected to each other. A PAN is a small Bluetooth network. A network that spans an area such as a city or a campus is a MAN. A SAN is designed specifically for storage, and a WLAN is like a LAN but wireless."
  },
  {
    "id": 262,
    "topic_id": 200,
    "title": "Know how computers connect to a network.",
    "description": "It might seem simple, but remember that all computers need a NIC to connect to the network. There's a lot of configuration that happens automatically, and you may need to reconfigure the NIC or update drivers if things don't work properly."
  },
  {
    "id": 263,
    "topic_id": 200,
    "title": "Understand what a MAC address is.",
    "description": "The media access control (MAC) address is physically associated with a network card. MAC addresses must be unique for them to work on a network."
  },
  {
    "id": 264,
    "topic_id": 200,
    "title": "Know about the different types of copper cable.",
    "description": "The three types of copper cable you should know about are coaxial, unshielded twisted pair (UTP), and shielded twisted pair (STP). UTP comes in various types, including Cat 5, Cat 5e, Cat 6, and Cat 6a (among others). For outdoor use, go with direct burial cable."
  },
  {
    "id": 265,
    "topic_id": 200,
    "title": "Understand the difference between a patch (straight-through) cable and a crossover cable.",
    "description": "Patch cables are used to connect hosts to a switch or a hub. Crossover cables switch pins 1 and 3 and 2 and 6 on one end. They are used to connect hubs to hubs, switches to switches, hosts to hosts, and hosts to routers."
  },
  {
    "id": 266,
    "topic_id": 200,
    "title": "Memorize the T568A and T568B cable standards.",
    "description": "As painful as it might sound, you should memorize the pin order for these two standards. The T568A order is white/green, green, white/orange, blue, white/blue, orange, white/brown, brown. T568B is white/orange, orange, white/green, blue, white/blue, green, white/brown, brown. If it helps, note that the blue and brown pairs do not change; only the green and orange pairs do."
  },
  {
    "id": 267,
    "topic_id": 200,
    "title": "Know what a plenum cable is used for.",
    "description": "Plenum cables do not release toxic gas when burned and therefore are required in spaces that circulate air (plenums) within buildings."
  },
  {
    "id": 268,
    "topic_id": 200,
    "title": "Understand performance characteristics of fiber-optic cable.",
    "description": "Fiber can support higher transmission rates and longer distances than copper cable can. It's also immune to electrical interference. Single-mode cables can run longer distances than multimode cables."
  },
  {
    "id": 269,
    "topic_id": 200,
    "title": "Know which types of connectors are used for the different types of network cables.",
    "description": "Coaxial cable uses F-type or BNC connectors. Twisted pair uses RJ11 or RJ45 connectors or can be terminated at a punchdown block. Fiber connectors include straight tip (ST), subscriber connector (SC), and Lucent (or local) connector (LC)."
  },
  {
    "id": 270,
    "topic_id": 200,
    "title": "Know which networking devices are used to connect to the Internet.",
    "description": "Digital connections are made through cable modems and DSL modems, and optical connections through optical network terminals (ONTs)."
  },
  {
    "id": 271,
    "topic_id": 200,
    "title": "Know what hubs, switches, access points, patch panels, and routers are.",
    "description": "These are all network connectivity devices. Hubs and switches are used to connect several computers or groups of computers to each other. Switches can be managed or unmanaged. An access point is any port where a computer plugs into a network, but the term typically refers to wireless access points. Patch panels are rack-mounted devices with multiple (usually dozens of) wired access points. Routers are more complex devices that are often used to connect network segments or networks to each other."
  },
  {
    "id": 272,
    "topic_id": 200,
    "title": "Know what a firewall and Power over Ethernet (PoE) provides.",
    "description": "A firewall is a security device that blocks or allows network traffic to pass through it. PoE provides for electricity over Ethernet cables."
  },
  {
    "id": 273,
    "topic_id": 200,
    "title": "Understand how IPv4 addressing works.",
    "description": "IP addresses are 32-bit addresses written as four octets in dotted-decimal notation, such as 192.168.5.18. To communicate on an IP network, a host also needs a subnet mask, which may look something like 255.255.255.0. If the host needs to communicate outside the local network, it also needs a default gateway, which is normally the internal address of the router."
  },
  {
    "id": 274,
    "topic_id": 200,
    "title": "Addresses can be static (manual) or dynamic (from a DHCP server). If a DHCP server is not available, a network client may use an APIPA address with the format 169.254.x.x. Be able to identify IP address classes.",
    "description": "Know how to identify Class A, B, and C IP addresses. Class A addresses will have a first octet in the 1 to 126 range. B is from 128 to 191, and C is from 192 to 223."
  },
  {
    "id": 275,
    "topic_id": 200,
    "title": "Understand the differences between TCP and UDP.",
    "description": "TCP is a connection-based protocol that attempts to guarantee delivery. UDP is connectionless, which makes it a bit faster, but it doesn't guarantee packet delivery."
  },
  {
    "id": 276,
    "topic_id": 200,
    "title": "Know common TCP/IP ports.",
    "description": "Some common protocol and port pairings that you should know are FTP (20 and 21), SSH (22), Telnet (23), SMTP (25), DNS (53), DHCP (67, 68), HTTP (80), POP3 (110), NetBIOS/NetBT (137-139), IMAP (143), LDAP (389), HTTPS (443), SMB/CIFS (445), and RDP (3389)."
  },
  {
    "id": 277,
    "topic_id": 200,
    "title": "Know the difference between public and private IP addresses.",
    "description": "Public addresses are routable on the Internet and must be globally unique. Private addresses are not routable on the Internet and are used behind a NAT device."
  },
  {
    "id": 278,
    "topic_id": 200,
    "title": "Know the private IP address ranges.",
    "description": "Private IP addresses will be in one of three ranges: 10.0.0.0/8, 172.16.0.0/12, or 192.168.0.0/16."
  },
  {
    "id": 279,
    "topic_id": 200,
    "title": "Know what NAT does.",
    "description": "Network Address Translation (NAT) translates private, nonroutable IP addresses into public IP addresses. It allows computers on a private network to access the Internet."
  },
  {
    "id": 280,
    "topic_id": 200,
    "title": "Know about the APIPA range.",
    "description": "IP addresses in the 169.254.0.0/16 range are APIPA addresses."
  },
  {
    "id": 281,
    "topic_id": 200,
    "title": "Understand how IPv6 addressing works.",
    "description": "IPv6 addresses are 128-bit addresses written as eight fields of four hexadecimal characters, such as 2001:0db8:3c4d:0012: 0000:0000:1234:56ab. Using shorthand conventions, this address can also be written as 2001:db8:3c4d:12::1234:56ab."
  },
  {
    "id": 282,
    "topic_id": 200,
    "title": "Know the difference between unicast, anycast, and multicast in IPv6.",
    "description": "Unicast addresses are for a single node on the network. Anycast can represent a small group of systems. An anycast message will be delivered to the closest node. Multicast messages are delivered to all computers within a group."
  },
  {
    "id": 283,
    "topic_id": 200,
    "title": "Recognize the special classes of IPv6 addresses.",
    "description": "The loopback address is ::1. Global unicast addresses are in the 2000::/3 range. Unique local unicast addresses are in the FC00::/7 range, link local addresses are FE80::/10, and FF00::/8 addresses are multicast."
  },
  {
    "id": 284,
    "topic_id": 200,
    "title": "Understand the differences between a VLAN and a VPN.",
    "description": "A virtual local area network (VLAN) is a logical network configured through a managed switch. A virtual private network (VPN) is a secure point-to-point connection over a public network."
  },
  {
    "id": 285,
    "topic_id": 200,
    "title": "Know the various roles that servers can play on a network.",
    "description": "Roles include DNS, DHCP, file (fileshare), print, mail, syslog, web, AAA, database, and NTP servers. File servers (fileshares) store files for users, and may have optical media and perform backups too. Print servers host printers. Mail servers store, send, and receive email. A syslog server is used to log system events. Web servers host web pages that users access across a network. AAA servers validate user credentials, and then allow users to access resources and track access. Database servers host databases and use a DBMS. NTP servers synchronize time across a network."
  },
  {
    "id": 286,
    "topic_id": 200,
    "title": "Know what DNS servers do.",
    "description": "DNS servers resolve hostnames to IP addresses. Without DNS servers, finding your favorite websites on the Internet would be an incredibly challenging task. DNS servers have a zone file with hostname to IP address mappings."
  },
  {
    "id": 287,
    "topic_id": 200,
    "title": "Know five common DNS record types and what each one does.",
    "description": "DNS record types include A, AAAA, CNAME, MX, and TXT. A is for IPv4 hosts and AAAA (quad A) is for IPv6 hosts. CNAME is an alias, MX is a mail server, and TXT is a text entry."
  },
  {
    "id": 288,
    "topic_id": 200,
    "title": "Understand how DNS helps mitigate spam email.",
    "description": "DNS uses DKIM, SPF, and DMARC to help fight email spam."
  },
  {
    "id": 289,
    "topic_id": 200,
    "title": "Understand how DHCP servers work.",
    "description": "DHCP servers lease IP addresses and configuration information to client computers. Clients request the information via broadcast. Each DHCP server has a scope with a configured range of available IP addresses. The server may also provide additional configuration information, such as the address of the default gateway (a router) and a DNS server. Scopes may also have exclusions and reservations."
  },
  {
    "id": 290,
    "topic_id": 200,
    "title": "Understand what spam gateways and UTM systems do.",
    "description": "Spam gateways help email servers detect and deal with unwanted spam email. Unified threat management (UTM) systems centralize security management and often replace traditional firewalls."
  },
  {
    "id": 291,
    "topic_id": 200,
    "title": "Know what load balancers and proxy servers do.",
    "description": "Both types of servers help manage network traffic. Load balancers do so by sending incoming requests to different, typically identical servers to spread out the workload. Proxy servers make requests on behalf of clients."
  },
  {
    "id": 292,
    "topic_id": 200,
    "title": "Know what legacy and embedded systems are.",
    "description": "Legacy systems are older technology no longer supported by the manufacturer. Embedded systems are those that are critical to a process. SCADA is an example of a legacy and embedded system."
  },
  {
    "id": 293,
    "topic_id": 200,
    "title": "Know some examples of services provided by Internet of Things (IoT) devices.",
    "description": "Some device types include thermostats, home security and automation, and voice-enabled speakers and digital assistants."
  },
  {
    "id": 294,
    "topic_id": 200,
    "title": "Know the different 802.11 standards.",
    "description": "Standards you should be familiar with are 802.11a, 802.11b, 802.11g, 802.11n, 802.11ac (Wi-Fi 5), 802.11ax (Wi-Fi 6), and 802.11be (Wi-Fi 7). Know the frequencies (2.4 GHz, 5 GHz, and 6 GHz) that each one uses, as well as performance characteristics of each, such as relative distance and speed."
  },
  {
    "id": 295,
    "topic_id": 200,
    "title": "Know the three nonoverlapping 2.4 GHz wireless channels.",
    "description": "If you need three nonoverlapping channels, you must use channels 1, 6, and 11."
  },
  {
    "id": 296,
    "topic_id": 200,
    "title": "Understand Bluetooth networking.",
    "description": "Bluetooth isn't used for wireless LAN like 802.11, but it is used for small personal area networks. It's best for peripheral connectivity such as headsets, keyboards, mice, and printers."
  },
  {
    "id": 297,
    "topic_id": 200,
    "title": "Understand the difference between RFID and NFC.",
    "description": "Both use radio signals. RFID is used to track the presence or location of items. NFC uses high-frequency RFID signals and can be used for touchless payment systems."
  },
  {
    "id": 298,
    "topic_id": 200,
    "title": "Know the different types of available broadband connections.",
    "description": "Broadband connections include DSL, cable, fiber, satellite, cellular, and wireless Internet service provider (WISP)."
  },
  {
    "id": 299,
    "topic_id": 200,
    "title": "Know the various cellular networking standards.",
    "description": "Understand the differences between 4G and 5G, and also how 5G has LTE and mmWave."
  },
  {
    "id": 300,
    "topic_id": 200,
    "title": "Know how to configure a network client to use IP addressing.",
    "description": "Clients can be configured with static IP information, or dynamically through a DHCP server. To communicate on the Internet, clients need an IP address, subnet mask, and gateway. On an internal network, you can use private IP addresses as long as they go through NAT to get to the Internet. APIPA is available as a fallback if a DHCP server is not available."
  },
  {
    "id": 301,
    "topic_id": 200,
    "title": "Understand the three encryption protocols used for wireless networking.",
    "description": "Listed in order from least to most secure, the common wireless security protocols include WPA, WPA2, and WPA3. WPA uses TKIP, WPA2 uses AES, and WPA3 uses AES-GCM."
  },
  {
    "id": 302,
    "topic_id": 200,
    "title": "Understand the differences between wireless specifications.",
    "description": "Know basic differences between 3G, 4G, and 5G, including what GSM and CDMA are and why they weren't compatible."
  },
  {
    "id": 303,
    "topic_id": 200,
    "title": "Know what a hotspot is.",
    "description": "A hotspot is a cellular-capable device such as a smartphone, that is sharing its cellular connection with other devices so they can access the Internet."
  },
  {
    "id": 304,
    "topic_id": 200,
    "title": "Know how to enable or disable wireless/cellular data connections.",
    "description": "Wireless connections are individually disabled through the Settings app on most phones or through a quick access screen. Airplane mode disables all wireless signals at once, when configured properly."
  },
  {
    "id": 305,
    "topic_id": 200,
    "title": "Know what SIM and eSIM are.",
    "description": "The Subscriber Identity Module (SIM) is the chip in the mobile device that identifies it. An eSIM is a circuit embedded into the device's motherboard that does the same function, but can be electronically reprogrammed, much like a BIOS/UEFI can be flashed."
  },
  {
    "id": 306,
    "topic_id": 200,
    "title": "Understand the steps needed to configure Bluetooth.",
    "description": "You need to enable Bluetooth, enable pairing, find a device for pairing, enter the appropriate PIN code (or confirm the PIN), and test connectivity."
  },
  {
    "id": 307,
    "topic_id": 200,
    "title": "Know the differences between GPS and cellular location services.",
    "description": "GPS is a free service provided by the government and uses satellites. Cellular location services use cell phone towers and require an account with a carrier."
  },
  {
    "id": 308,
    "topic_id": 200,
    "title": "Know the purposes of MDM and MAM.",
    "description": "Mobile device management (MDM) is primarily used to determine which mobile devices are allowed on a network and to set policies for access. MDM also provides mechanisms for remotely locking and wiping devices. Mobile application management (MAM) is for managing corporate applications on mobile devices."
  },
  {
    "id": 309,
    "topic_id": 200,
    "title": "Know which protocols are used for email and which ports they use.",
    "description": "POP3 (port 110) and IMAP (port 143) are used to receive email, and SMTP (port 25) is used to send email. None of these protocols are inherently secure. They can be secured with SSL or TLS. SMTP over SSL uses port 465, and SMTP over TLS uses port 587. IMAP over SSL/TLS uses port 993, and POP over SSL/TLS uses port 995."
  },
  {
    "id": 310,
    "topic_id": 200,
    "title": "Understand the differences between managing corporate devices and BYOD devices.",
    "description": "Corporate devices are owned by the company or organization, and all content on them is considered property of that company. BYOD devices are owned by the end user and allowed to participate on the company network. BYOD configurations can be less secure because there can be multiple device types and OSs, but using a BYOD policy can save companies money."
  },
  {
    "id": 311,
    "topic_id": 200,
    "title": "Be familiar with four commercial email providers and required configuration items.",
    "description": "Common commercial email providers are Gmail, iCloud, Exchange Online, and Yahoo Mail. Each provider has its own inbound and outbound servers, but most of the time that configuration information is automatically provided when you try to connect to them with an email client."
  },
  {
    "id": 312,
    "topic_id": 200,
    "title": "Know which types of data are often synchronized.",
    "description": "Common data types for synchronization include calendars and contacts, but literally any data on a mobile device can be synchronized. This includes business applications such as email, and cloud storage."
  },
  {
    "id": 313,
    "topic_id": 200,
    "title": "Understand the purpose of virtual machines.",
    "description": "Virtual machines are designed to save providers and users money. They allow for multiple OSs to be installed on one computer. VMs can provide sandboxing, test development, and application virtualization for legacy software and OSs and cross-platform virtualization."
  },
  {
    "id": 314,
    "topic_id": 200,
    "title": "Understand virtual machine requirements.",
    "description": "A virtual machine has security, network, and storage requirements. Those requirements will tie back to physical resources available on a server somewhere."
  },
  {
    "id": 315,
    "topic_id": 200,
    "title": "Understand what virtual desktops are.",
    "description": "A virtual desktop is the collection of software and hardware needed to create a virtual environment. Sometimes it's called a virtual desktop infrastructure (VDI)."
  },
  {
    "id": 316,
    "topic_id": 200,
    "title": "Know what the hypervisor is, and the differences between Type 1 and Type 2 hypervisors.",
    "description": "The hypervisor is the software which allows the creation of virtual machines on a computer. A Type 1 (or bare-metal) hypervisor sits directly on the hardware and does not need a separate OS. This is mostly used for server-side virtualization. A Type 2 hypervisor sits on top of a host OS."
  },
  {
    "id": 317,
    "topic_id": 200,
    "title": "Know what containers are.",
    "description": "Containers are an app and the required files (such as OS files and dependencies) needed to run the app in any environment."
  },
  {
    "id": 318,
    "topic_id": 200,
    "title": "Understand the four different types of clouds.",
    "description": "A cloud can be public, private, hybrid, or community."
  },
  {
    "id": 319,
    "topic_id": 200,
    "title": "Know the differences between SaaS, IaaS, and PaaS.",
    "description": "All of these are cloud terms. In infrastructure as a service (IaaS), the provider supplies the network infrastructure. In platform as a service (PaaS), software development tools and platforms are also provided. The highest level is software as a service (SaaS), where the provider supplies the infrastructure and applications."
  },
  {
    "id": 320,
    "topic_id": 200,
    "title": "Understand shared resources versus dedicated resources.",
    "description": "All clouds use shared resources, which can be internal or external. A pool of resources is purchased and each participant in the cloud pays for part of it. The resources are shared resources. Dedicated resources would be wholly owned by one company."
  },
  {
    "id": 321,
    "topic_id": 200,
    "title": "Understand metered utilization, including ingress and egress.",
    "description": "Metered utilization shows how much a client has used and will be billed for. Ingress is loading data to the cloud (which is usually free), and egress is downloading data from the cloud (which may come with an extra cost)."
  },
  {
    "id": 322,
    "topic_id": 200,
    "title": "Know what elasticity and availability mean in the cloud.",
    "description": "Elasticity means that a client can quickly get more (or fewer) resources as needed. Availability means that services are always or almost always available, such as three nines five."
  },
  {
    "id": 323,
    "topic_id": 200,
    "title": "Know what file synchronization means in the cloud.",
    "description": "Synchronization means that an exact copy of the file is in multiple locations. Cloud file storage services include iCloud and Google Cloud, and in most cases have synchronization apps to sync to the mobile device."
  },
  {
    "id": 324,
    "topic_id": 200,
    "title": "Understand multitenancy.",
    "description": "Multiple clients can use the same hardware resources from a single cloud provider, which is called multitenancy."
  },
  {
    "id": 325,
    "topic_id": 200,
    "title": "Understand what happens during the POST routine.",
    "description": "During the power-on self-test (POST), the BIOS/UEFI checks to ensure that the base hardware is installed and working. Generally, one POST beep is good. Any more than that and you might have an error."
  },
  {
    "id": 326,
    "topic_id": 200,
    "title": "Understand problems related to the system BIOS/UEFI.",
    "description": "BIOS/UEFI settings are maintained by the CMOS battery when the system is powered off. If the system keeps losing the date and time or boot settings, it could indicate a problem with the CMOS battery."
  },
  {
    "id": 327,
    "topic_id": 200,
    "title": "Know what is likely to cause unexpected shutdowns, system lockups, continuous reboots, and intermittent device failures.",
    "description": "All these issues can be caused by a failing motherboard, CPU, or RAM. In the case of other intermittent device failures, it could be that specific device as well. Many times these issues are exacerbated by overheating."
  },
  {
    "id": 328,
    "topic_id": 200,
    "title": "Understand common problems that power supplies can cause.",
    "description": "Power supplies can fry components, but they can also cause no power, grinding or squealing noises, spinning fans but no power to other devices, smoke, and burning smells."
  },
  {
    "id": 329,
    "topic_id": 200,
    "title": "Know which devices within a system can make unusual noises.",
    "description": "Unusual noises are not pleasant to hear. Generally speaking, only devices with moving parts, such as HDDs, power supplies, and fans, can produce unwanted unusual noises."
  },
  {
    "id": 330,
    "topic_id": 200,
    "title": "Know how to avoid overheating.",
    "description": "Using fans and heat sinks will help to avoid overheating. Also know that overclocking the processor can cause overheating."
  },
  {
    "id": 331,
    "topic_id": 200,
    "title": "Know the proprietary crash screens for Windows and Mac operating systems.",
    "description": "Windows has the Blue Screen of Death (BSOD), whereas macOS uses the pinwheel."
  },
  {
    "id": 332,
    "topic_id": 200,
    "title": "Understand what a distended capacitor is.",
    "description": "It's when a capacitor swells and possibly bursts, releasing a reddish-brown electrolyte. A motherboard with distended capacitors will likely fail. Don't touch the electrolyte!"
  },
  {
    "id": 333,
    "topic_id": 200,
    "title": "Know what causes a black screen.",
    "description": "Black screens are likely the fault of the video card, video cable, or display unit. If the video circuitry is built into the motherboard, it could be a faulty motherboard as well."
  },
  {
    "id": 334,
    "topic_id": 200,
    "title": "Understand causes of sluggish performance.",
    "description": "Generally, sluggish performance is related to the memory or hard drive. If either are being overused, the system will be slower to respond. Overworked CPUs can also cause sluggish performance."
  },
  {
    "id": 335,
    "topic_id": 200,
    "title": "Know what causes application crashes.",
    "description": "App crashes are most likely one of two things: a poorly coded app or faulty memory."
  },
  {
    "id": 336,
    "topic_id": 200,
    "title": "Understand common issues related to hard drives and RAID arrays.",
    "description": "There are several issues that are hard drive\u2013related. The drive can have a read/write failure or slow performance. If a conventional drive fails, it might produce a loud clicking or scratching noise. Sometimes boot failures are hard drive\u2013related, if the drive can't be found or recognized or the OS isn't found due to a bad boot sector or master boot record. If the OS crashes, it may produce a proprietary crash screen, such as the BSOD in Windows or the pinwheel in macOS. RAID arrays are collections of hard drives and can have similar failures and issues with not being found. All hard drives made today have S.M.A.R.T. diagnostics built into them."
  },
  {
    "id": 337,
    "topic_id": 200,
    "title": "Know what to check if your wireless networking card isn't working.",
    "description": "Make sure the card has lights indicating that it's working. You might also have an external toggle switch to turn the card on and off. Finally, if your computer has an external RJ-45 connection, you can plug it in and see if it works when wired."
  },
  {
    "id": 338,
    "topic_id": 200,
    "title": "Understand what various networking hardware tools are used for.",
    "description": "Crimpers are for cutting and stripping cables and putting the connectors on the ends. Cable strippers are similar but don't put connectors on. A Wi-Fi analyzer examines wireless network signals. Toner probes allow you to trace a cable from one point to another. Punch-down tools connect wires to frames, such as a 110 block. A cable tester allows you to verify that a cable works; loopback plugs test the functionality of network cards. A network tap creates a copy of network traffic for use by monitoring devices without disrupting normal traffic."
  },
  {
    "id": 339,
    "topic_id": 200,
    "title": "Know what the ipconfig, ping, and tracert commands are used for.",
    "description": "Admittedly, these are specifically for A+ exam 220-1202, but know what they do. Both ipconfig and ping are network troubleshooting commands. You can use ipconfig to view your computer's IP configuration and ping to test connectivity between two network hosts. (The ip command in macOS and Linux is equivalent to ipconfig in Windows.) tracert allows you to view the network path a packet takes from the host to the destination."
  },
  {
    "id": 340,
    "topic_id": 200,
    "title": "Know what the netstat, net, and nslookup commands are used for.",
    "description": "These commands need to be understood for Exam 220-1202 as well. netstat shows network statistics; net allows you to perform network-management tasks, such as sharing folders; and nslookup allows you to query a DNS server."
  },
  {
    "id": 341,
    "topic_id": 200,
    "title": "Understand common video, projector, and display input issues.",
    "description": "Two input issues video displays might have are incorrect input source and physical cabling issues. If the source is incorrect, there will be no display. This is usually fixed by changing the input source from a menu on the display or within the operating system. If there is a physical cabling issue, the cable likely needs to be replaced."
  },
  {
    "id": 342,
    "topic_id": 200,
    "title": "Understand common video, projector, and display image problems.",
    "description": "There are a variety of image problems a video display could have. They include a burnt-out bulb, fuzzy image, sizing issues, distorted image, display burn-in, dead pixels, flashing screen or flickering screen, incorrect color display, or dim image. These will either be fixed through a setting or by replacing defective hardware."
  },
  {
    "id": 343,
    "topic_id": 200,
    "title": "Understand other issues video, projector, and display systems may have.",
    "description": "Many video systems have audio output, so audio issues may be related to the display device itself. Another issue is intermittent projector shutdown, which is typically related to overheating."
  },
  {
    "id": 344,
    "topic_id": 200,
    "title": "Understand common mobile device power and heat issues.",
    "description": "Power issues can include a battery not charging, no power, extremely short battery life (poor battery health), overheating, and a swollen battery."
  },
  {
    "id": 345,
    "topic_id": 200,
    "title": "Know what to do to resolve common mobile device input problems.",
    "description": "These can include sticking keys, ghost cursor or pointer drift, num lock lights, a stylus that doesn't work, or an unresponsive digitizer/touch screen. Be familiar with the laptop Function key and the features it controls, including switching the display to an external monitor."
  },
  {
    "id": 346,
    "topic_id": 200,
    "title": "Understand other issues common to mobile devices.",
    "description": "Other issues to know include physical damage such as from dropping or liquid damage, broken screens, physically damaged ports, malware, unable to install new applications, and degraded performance."
  },
  {
    "id": 347,
    "topic_id": 200,
    "title": "Know how to set IP addresses on a printer.",
    "description": "The IP address can often be obtained automatically from a DHCP server, but this is not recommended for corporate networks. Instead, use a static IP address (or use a DHCP reservation). You may be able to use the printer's control panel or printer management software to configure the IP address."
  },
  {
    "id": 348,
    "topic_id": 200,
    "title": "Know what could cause the printer to print garbage.",
    "description": "Most often, the print driver causes this. Deleting and reinstalling it should fix the problem. A defective formatter board can also cause it."
  },
  {
    "id": 349,
    "topic_id": 200,
    "title": "Understand what could cause print-quality issues on an impact printer.",
    "description": "Print-quality issues are generally related to either the ribbon or the printhead. The specific problem you are having will help determine the culprit."
  },
  {
    "id": 350,
    "topic_id": 200,
    "title": "Know what can cause unevenly spaced lines or characters on a dot-matrix or inkjet printer.",
    "description": "A failing stepper motor usually causes this. For line spacing problems, it's the main stepper motor. For character spacing, it will be the carriage stepper motor."
  },
  {
    "id": 351,
    "topic_id": 200,
    "title": "Know what causes printers to have paper problems.",
    "description": "On an impact printer, paper jams are usually caused by material getting into the rollers, such as extra \u201cperf\u201d from the tractor-feed paper. On inkjets and laser printers, worn pickup rollers often cause this problem. These same mechanisms can affect paper not feeding as well or multipage misfeeds."
  },
  {
    "id": 352,
    "topic_id": 200,
    "title": "Be familiar with troubleshooting a variety of printer output quality issues.",
    "description": "Issues to know include lines down the printed pages, garbled prints, faded prints, speckling on printed pages, double/echo images on the print, finishing issues such as staple jams or hole punch problems, incorrect page orientation, or the printer tray not being recognized."
  },
  {
    "id": 353,
    "topic_id": 200,
    "title": "Understand print spooler issues and know how to stop and restart the print spooler.",
    "description": "Print spooler issues can include multiple prints pending in the queue and a frozen print queue. To fix these, stop and restart the print spooler."
  }
];
